import { Box } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import type { HeatQueueStatus } from "src/store/api/generatedApi";

const STATUS_COLOUR: Record<HeatQueueStatus, string> = {
  melting: "warning.main",
  loading: "info.main",
  queued: "text.secondary",
  completed: "text.disabled",
};

export const HeatStatusPill = ({ status }: { status: HeatQueueStatus }) => {
  const { t } = useTenantTranslation();
  const labels: Record<HeatQueueStatus, string> = {
    melting: t("heatStatusMelting"),
    loading: t("heatStatusLoading"),
    queued: t("heatStatusQueued"),
    completed: t("completed"),
  };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 0.75,
        py: 0.25,
        border: 1,
        borderRadius: 1,
        borderColor: STATUS_COLOUR[status],
        color: STATUS_COLOUR[status],
        textTransform: "uppercase",
        typography: "caption",
        fontWeight: "fontWeightBold",
      }}
    >
      {labels[status]}
    </Box>
  );
};
